import { CanMatchFn } from '@angular/router';
import { inject } from '@angular/core';
import { SubdomainResolver } from '../resolvers/subdomain.resolver';

/**
 * Guard that only allows this route to match if we're on the root domain (no subdomain)
 * If on a subdomain, returns false so Angular tries the next route
 */
export const rootDomainGuard: CanMatchFn = () => {
    const subdomainResolver = inject(SubdomainResolver);
    const subdomain = subdomainResolver.resolve();

    // Allow route to match only if no subdomain (root domain)
    // If false, Angular will try the next route instead of failing navigation
    return subdomain === null;
};
